import { Injectable } from '@angular/core';
import { StudentInternshipDetailsModel } from 'common/models/page-models/student-side/internship-detail/student-internship-detail-data.model';
import {
  StudentFeedback,
  studentInternshipDataModel,
  StudentInternshipDetailsMetaModel,
  StudentInternShipKeyDetails,
} from 'common/models/page-models/student-side/internship-detail/student-internship-detail-meta.model';
import {
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import {
  SmMetaInputModel,
  SmMetaTextAreaModel,
} from 'common/models/utility-models/meta-model';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentFeedbackQuestionsDataService } from 'common/services/data-services/student/student-internship/student-feedback-question-data.service';
import { StudentInternshipDetailDataService } from 'common/services/data-services/student/student-internship/student-internship-detail.service';
import { FormWidgetService } from 'common/widget/form-widget.service';

@Injectable({
  providedIn: 'root',
})
export class StudentInternshipDetailWidgetService extends FormWidgetService<StudentInternshipDetailsModel> {
  constructor(
    protected ds: StudentInternshipDetailDataService,
    protected systemService: SystemService,
    protected fq: StudentFeedbackQuestionsDataService
  ) {
    super(ds);
  }

  override prepareMetaModel(
    dataModel: any,
    metaModel: any,
    routeData: WidgetModel,
    event = null
  ): Promise<StudentInternshipDetailsMetaModel> {
    return new Promise<StudentInternshipDetailsMetaModel>((resolve, reject) => {
// console.log(routeData,dataModel,'INSIDE PREPARE METAMODEL');

if(dataModel.isStudentContinued == 0){
  metaModel.properties.isInternshipCompletedFieldSubmitted = false;
} else {
  metaModel.properties.isInternshipCompletedFieldSubmitted = true;
}

if(dataModel.isStudentJoined && dataModel.isStudentContinued == 1){
  metaModel.properties.isStudentJoinedAndContinued = true;
} else {
  metaModel.properties.isStudentJoinedAndContinued = false;
}

metaModel.properties.isStudentJoined = dataModel.isStudentJoined

      let endDate = new Date(
        dataModel.studentExpectedInternshipEndDate
      ).getTime();
      let date = new Date().getTime();

      if (
        date >= endDate &&
        dataModel.studentExpectedInternshipEndDate !== null &&
        dataModel.studentExpectedInternshipEndDate !== ""
      ) {
        metaModel.properties.uploadFile = true;
      }

      let givenDate = new Date(dataModel.internshipStartDate).getTime();
      let continueDate = new Date(dataModel.internshipEndDate).getTime();
      if (date >= givenDate) {
        metaModel.properties.joined = true;
      }

      if (date >= continueDate) {
        metaModel.properties.continued = true;
      }

     
  
      if (dataModel.isStudentAvailable !== 0) {
        metaModel.properties.isEditable.forEach((item) => {
          item.readOnly = true;
          item.propreadOnly = true;
          if (item.hasOwnProperty('propisPlaceholder')) {
            item.propisPlaceholder.isPlaceholder = false;
            item.propisPlaceholder.isIconVisible = false;
          }
        });

        metaModel.properties.isvisible=true;

        if (
          !(
            dataModel.isStudentAvailable === 2 &&
            dataModel.isExternalCompanyForInternship === 0
          )
        ) {
          metaModel.properties.studentAvailabilityRemark.isHidden = false;
        }

        if (
          dataModel.isStudentAvailable === 2 &&
          dataModel.isExternalCompanyForInternship === 1
        ) {
          metaModel.properties.externalCompanyName.isHidden = false;
          metaModel.properties.externalCompanyLocation.isHidden = false;
        }

        metaModel.properties.buttons.submit.isHideButton = true;

        dataModel.studentExamStartDate = new Date(
          dataModel.studentExamStartDate
        );
        // console.log(dataModel.studentExamStartDate);
        dataModel.studentExamEndDate = new Date(dataModel.studentExamEndDate);
        dataModel.studentSummerVacationStartDate = new Date(
          dataModel.studentSummerVacationStartDate
        );
        dataModel.studentSummerVacationEndDate = new Date(
          dataModel.studentSummerVacationEndDate
        );
        dataModel.studentExpectedInternshipStartDate = new Date(
          dataModel.studentExpectedInternshipStartDate
        );
        dataModel.studentExpectedInternshipEndDate = new Date(
          dataModel.studentExpectedInternshipEndDate
        );
      }

      else if(dataModel.isStudentAvailable === 0)
      {
        metaModel.properties.isvisible=false;
        metaModel.properties.isInternshipJoined=false;

      }


       
      // const prepareInternShipData: studentInternshipDataModel =
      //   new studentInternshipDataModel();

      // prepareInternShipData.studentInternshipSubTitle.forEach((details) => {
      //   details.showLabels.forEach((labels, index) => {
      //     const keyValue = new StudentInternShipKeyDetails();
      //     keyValue.showLabel = labels;
      //     keyValue.showValue =
      //       dataModel[details.keyLabels[index]] === 0
      //         ? 'NO'
      //         : dataModel[details.keyLabels[index]] === null
      //         ? 'N/A'
      //         : dataModel[details.keyLabels[index]] === 1
      //         ? 'YES'
      //         : dataModel[details.keyLabels[index]];
      //     details.keyDetails.push(keyValue);
      //   });
      // });

      function getDateSuffix(day: number): string {
        if (day >= 11 && day <= 13) return 'th';
        switch (day % 10) {
          case 1:
            return 'st';
          case 2:
            return 'nd';
          case 3:
            return 'rd';
          default:
            return 'th';
        }
      }
      const prepareInternShipData: studentInternshipDataModel = new studentInternshipDataModel();
      new studentInternshipDataModel();
      // prepareInternShipData.studentInternshipSubTitle.forEach((details) => {
      //   details.showLabels.forEach((labels, index) => {
      //     const keyValue = new StudentInternShipKeyDetails();
      //     keyValue.showLabel = labels;
      
      //     const currentKey = details.keyLabels[index];
      //     const currentValue = dataModel[currentKey];
      
      //     if (currentKey === 'internshipStatusByMentor') {
      //       keyValue.showValue =
      //         currentValue === 0
      //           ? 'In-complete'
      //           : currentValue === 1
      //           ? 'Complete'
      //           : 'In-complete';
      //     } else {
      //       keyValue.showValue =
      //         currentValue === 0
      //           ? 'NO'
      //           : currentValue === null
      //           ? 'N/A'
      //           : currentValue === 1
      //           ? 'YES'
      //           : currentValue;
      //     }
      
      //     details.keyDetails.push(keyValue);
      //   });
      // });
      
      prepareInternShipData.studentInternshipSubTitle.forEach((details) => {
        details.showLabels.forEach((labels, index) => {
          const keyValue = new StudentInternShipKeyDetails();
          keyValue.showLabel = labels;
      
          const currentKey = details.keyLabels[index];
          const currentValue = dataModel[currentKey];
      
          if (currentKey === 'internshipStatusByMentor') {
            keyValue.showValue =
              currentValue === 0
                ? 'In-complete'
                : currentValue === 1
                ? 'Complete'
                : 'In-complete';
          } else if (
            [
              'internshipStartDate',
              'internshipEndDate',
              'studentSummerVacationStartDate',
              'studentSummerVacationEndDate',
              'studentExamStartDate',
              'studentExamEndDate',
              'studentExpectedInternshipStartDate',
              'studentExpectedInternshipEndDate',
            ].includes(currentKey)
          ) {
            const date = new Date(currentValue);
            if (!isNaN(date.getTime())) {
              const day = date.getDate();
              const month = date.toLocaleString('default', { month: 'short' }); // Get month name
              const year = date.getFullYear();
              const suffix = getDateSuffix(day);
      
              keyValue.showValue = `${day}${suffix} ${month} ${year}`;
            }else {
              keyValue.showValue = 'N/A';
            }
          } else {
            keyValue.showValue =
              currentValue === 0
                ? 'NO'
                : currentValue === null
                ? 'N/A'
                : currentValue === 1
                ? 'YES'
                : currentValue;
          }
      
          details.keyDetails.push(keyValue);
        });
      });
      
      const newFeedBack = new StudentFeedback();
      // console.log(dataModel);
      dataModel.studentFeedback.forEach((feedBack: any) => {
        const keyValue = new StudentInternShipKeyDetails();
        keyValue.showLabel = feedBack.question;
        keyValue.questionType = feedBack.questionType;
        if (feedBack.questionType === 1) {
          feedBack.options.filter((question) => {
            if (question.optionId === feedBack?.answer) {
              keyValue.showValue = question.option_text;
            }
          });
        } else if ([2, 4, 0].includes(feedBack.questionType)) {
          keyValue.showValue = feedBack?.answer;
        } else if (feedBack.questionType === 3) {
          keyValue.showValue = feedBack?.answer;
        }

        newFeedBack.keyDetails.push(keyValue);
      });
      prepareInternShipData.studentFeedBack = newFeedBack;
      metaModel.properties.internshipcompleteDetails = prepareInternShipData;
      // routeData.transferData.transferData.tabnumber=2;
      metaModel.properties.tabNumber =
        routeData.transferData.transferData.tabnumber;
        // console.log(routeData.transferData.transferData.tabnumber);
        
      if (routeData.transferData.transferData.tabnumber === 2) {
        if (dataModel.studentFeedback.length === 0) {
          this.fq.postData({}).then((data) => {
            // console.log(data,'fr')
            dataModel.studentFeedback = data.details;
            this.metaModelCreate(data.details, dataModel, metaModel);
            resolve(metaModel);
          });
        } else {
          this.metaModelCreate(dataModel.studentFeedback, dataModel, metaModel);
          resolve(metaModel);
        }

        //  }
      }else{
        resolve(metaModel);
      }
      //  dataModel.studentFeedback.forEach((question:any) => {
      //     dataModel[question.id] = question.answer || '';

      //   });
 

      if (
        routeData.transferData.transferData.tabnumber === 1 ||
        routeData.transferData.transferData.tabnumber === 3 ||
        routeData.transferData.transferData.tabnumber === 4
      ) {
        resolve(metaModel);
      }
    });
  }

  metaModelCreate(data, dataModel, metaModel) {
    try{
    data.forEach((question: any) => {
      // console.log(question.questionType,'questionType')
      switch (question.questionType) {
        case 3:
          metaModel.properties[question.id] = new SmMetaInputModel(
            String(question.id),
            String(question.id),
            'ratings',
            false,
            'col-12 col-md-6',
            1,
            1,
            question.question,
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
          );
          metaModel.properties[question.id]['answer'] = 'answer';
          metaModel.properties[question.id]['learningType'] =
            question.learningType;
          metaModel.properties[question.id]['skillType'] = question.skillType;
          break;
        case 0:
          metaModel.properties[question.id] = new SmMetaTextAreaModel(
            String(question.id),
            String(question.id),
            'SimpleTextarea',
            false,
            'col-12 col-md-6',
            1,
            1,
            question.question,
            'text',
            '',
            false,
            true,
            true,
            false,
            500,
            1,
            false,
            false
          );
          metaModel.properties[question.id]['answer'] = 'answer';
          metaModel.properties[question.id]['learningType'] =
            question.learningType;
          metaModel.properties[question.id]['skillType'] = question.skillType;
          break;
      }
      dataModel[question.id] = question.answer || '';
    });
  }catch(err){
    console.log(err,'error')
  }
  }

  getMetaModel(): MetaModel {
    const meta = new StudentInternshipDetailsMetaModel().getMetaModel();
    return meta;
  }

  refreshPage(params:any,widget:any): Promise<any>{
    return new Promise<any>((resolve, reject) => {
      this.ds.getDataById(params).then((data) =>{
        console.log("RESPONSE WS",data);
        
        const models = {
          dataModel: data
      };
        this.prepareMetaModel(data, this.getMetaModel(), widget).then((metaModel)=>{
          models['metaModel'] = metaModel;
          resolve(models);
        })
      })
    })
  }
}
